import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService} from './base.service';
import {map} from 'rxjs/operators';
import {MoyenModel} from '../models/moyens/moyen.model';
import {FavorisModel} from '../models/moyens/favoris.model';
import {ExtractionFilterModel} from "../models/extractionFilter.model";
import {HttpHeaders, HttpResponse} from "@angular/common/http";
import { MimeTypeEnum } from '../models/enum/mime-type-enum';
import {RecurrenceModel} from '../models/moyens/recurrence.model';

export type CategorieMoyenAgregat = { categorie: string, nombre: number };
export type TypeMoyenAgregat = { type: string, nombre: number };
export type MatiereMoyenAgregat = { matiere: string, nombre: number };

@Injectable({providedIn: 'root'})
export class MoyenService extends BaseService {
  private readonly url:string = 'moyens/'

  importTuto(i, pdf): Observable<boolean> {
    const file: File = pdf;
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.postFile(environment.apiPath + 'document/importPdf/' + i, formData).pipe(
      map(item => {
        return true;
      }),
    );
  }

  getSingleMoyen(idMoyen): Observable<MoyenModel> {
    return this.get(environment.apiPath + 'moyens/' + idMoyen).pipe(
      map(item => {
        return item as MoyenModel;
      }))
  }

  getListMoyens(filtre): Observable<Array<MoyenModel>> {
    return this.post(environment.apiPath + 'moyens/list/', filtre).pipe(
      map(item => {
        return item as Array<MoyenModel>;
      }))
  }

  getListRecurrences(filtre): Observable<Array<RecurrenceModel>> {
    return this.post(environment.apiPath + 'moyens/recurrences/', filtre).pipe(
      map(item => {
        return item as Array<RecurrenceModel>;
      }))
  }

  getRecurrence(id): Observable<Array<MoyenModel>> {
    return this.get(environment.apiPath + 'moyens/recurrence/' + id).pipe(
      map(item => {
        return item as Array<MoyenModel>;
      }))
  }

  deleteMoyen(array): Observable<unknown> {
    return this.post(environment.apiPath + 'moyens/delete/', array).pipe(
      map(item => {
        return item;
      }))
  }

  addMoyen(moyen): Observable<unknown> {
    return this.post(environment.apiPath + 'moyens/add/', moyen)
  }

  deleteRecurrence(recurrenceId): Observable<unknown> {
    return this.post(environment.apiPath + 'moyens/delRecurrence/', recurrenceId).pipe(
      map(item => {
        return item;
      }))
  }

  getNbRecurrences(idUsine): Observable<number> {
      return this.get(environment.apiPath + 'moyens/nbrecurrences/' + idUsine).pipe(
      map(item => {
        return item as number;
      }))
  }

  getNbMoyens(moyenFilter): Observable<number> {
    return this.post(environment.apiPath + 'moyens/nbmoyens', moyenFilter).pipe(
      map(item => {
        return item as number;
      }))
  }

  getMoyenFiltred(moyenFilter): Observable<Array<MoyenModel>> {
    return this.post(environment.apiPath + 'moyens/filtre/', moyenFilter).pipe(
      map(item => {
        return item as Array<MoyenModel>;
      }),
    );
  }

  getMoyenByKeyWord(moyenFilter): Observable<Array<MoyenModel>> {
    return this.post(environment.apiPath + 'moyens/list/', moyenFilter).pipe(
      map(item => {
        return item as Array<MoyenModel>;
      }),
    );
  }

  getMoyenFavoris(id): Observable<Array<MoyenModel>> {
    return this.get(environment.apiPath + 'moyens/favoris/' + id).pipe(
      map(item => {
        return item as Array<MoyenModel>;
      }),
    )
  }

  addMoyenFavoris(favoris): Observable<unknown> {
    return this.post(environment.apiPath + 'moyens/addfavoris/', favoris)
  }

  newRecurrence(recurrence): Observable<number> {
    return this.post(environment.apiPath + 'moyens/newrecurrence/', recurrence).pipe(
      map(item => {
        return item as number;
      }),
    )
  }

  addRecurrence(recurrence): Observable<unknown> {
    return this.post(environment.apiPath + 'moyens/addrecurrences/', recurrence)
  }

  importMoyen(usineValue, xls): Observable<unknown> {
    const file: File = xls;
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('site', usineValue);
    return this.postFile(environment.apiPath + 'moyens/import/', formData);
  }

  getMatiere(temp): Observable<Array<MatiereMoyenAgregat>> {
    return this.post(environment.apiPath + 'moyens/matiere/', temp).pipe(
      map(item => {
        return item as Array<MatiereMoyenAgregat>;
      }),
    );
  }

  getType(temp): Observable<Array<TypeMoyenAgregat>> {
    return this.post(environment.apiPath + 'moyens/type/', temp).pipe(
      map(item => {
        return item as Array<TypeMoyenAgregat>;
      }),
    );
  }

  getCategories(idUsine): Observable<Array<CategorieMoyenAgregat>> {
    return this.get(environment.apiPath + 'moyens/categories/' + idUsine).pipe(
      map(item => {
        return item as Array<CategorieMoyenAgregat>;
      }),
    );
  }

  exportMoyens(filtre: { site?: number }): Observable<HttpResponse<Blob>> {
    const filtreToSend: MoyenModel = new MoyenModel();
    //On veut filtrer seulement sur l'usine
    filtreToSend.site = filtre.site;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${environment.apiPath}${this.url}export/`, filtreToSend, { headers, observe: 'response', responseType: 'blob' })
      .pipe(
        map(response => {
          this.downloadFile(response);
          return response;
        })
      );
  }

  private downloadFile(response: HttpResponse<Blob>): void {
    const blob = new Blob([response.body], { type: MimeTypeEnum.XLSX });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'export_moyens';
    link.click();
  }
}

